const handleClick = (event) => {
	event.preventDefault();
	const { href } = event.target.closest('button').dataset;
	window.location = href;
}

const buttons = document.querySelectorAll('button[id^="sso-"]');

[...buttons].forEach((button) => {
	button.addEventListener('click', (evt) => handleClick(evt));
})
